import { currentLanguage, Languages } from 'helpers/language'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import es from './es.json'

export const defaultNS = 'sandbox'
export const resources = {
  en: {
    [defaultNS]: en
  },
  es: {
    [defaultNS]: es
  }
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: currentLanguage || Languages.English
})

export default i18n
